<div class="page">
  @if (text) {
    <div class="page-header">
      <h1 class="page-title">{{ text }}</h1>
    </div>
  }
  <ng-content></ng-content>
</div>
